export default function programBrochureTabs(programAlias, programTabs = []) {
  const defaultTabs = [
    {
      title: `${programAlias} Overview`,
      path: '',
      component: 'programOverview',
      identifier: 'program_overview',
    },
    {
      title: `About ${programAlias}`,
      path: 'about-program',
      component: 'aboutProgram',
      identifier: 'about_program',
    },
    {
      title: 'Academics',
      path: 'academics',
      component: 'academics',
      identifier: 'academics',
    },
    {
      title: 'Term Information',
      path: 'term-information',
      component: 'termInformation',
      identifier: 'term_information',
    },
    {
      title: `What's Included`,
      path: 'whats-included',
      component: 'whatsIncluded',
      identifier: 'whats_included',
    },
    {
      title: 'Eligibility',
      path: 'eligibility',
      component: 'eligibility',
      identifier: 'eligibility',
    },
    {
      title: 'Cost & Funding',
      path: 'cost-and-funding',
      component: 'costAndFunding',
      identifier: 'costs_and_funding',
    },
    {
      title: 'Resources',
      path: 'resources',
      component: 'resources',
      identifier: 'resources',
    },
  ]
  return defaultTabs.map(tab => {
    const matchingCustomTab = programTabs.find(
      t => t.identifier === tab.identifier
    );

    return {
      ...tab,
      title:
        matchingCustomTab?.custom_name?.trim()
          ? matchingCustomTab.custom_name
          : tab.title,
    };
  });
}
